import React, { PureComponent } from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import { Icon, Input } from 'semantic-ui-react';

import moment from 'moment';
import Calendar from 'rc-calendar';
import DatePicker from 'rc-calendar/lib/Picker';
import TimePickerPanel from 'rc-time-picker/lib/Panel';

import heIL from 'rc-calendar/lib/locale/he_IL';
import enUS from 'rc-calendar/lib/locale/en_US';

import 'rc-time-picker/assets/index.css';
import 'rc-calendar/assets/index.css';

import './DateTimePicker.scss';

const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm";

class DateTimePicker extends PureComponent {
    state = {
    };

    constructor(props) {
        super(props);

        this.renderPickerInput = this.renderPickerInput.bind(this);
        this.renderTimePicker = this.renderTimePicker.bind(this);
        this.renderCalendar = this.renderCalendar.bind(this);
    }


    renderPickerInput({ value }) {
        const { pickerInputStyle } = this.props;

        return (
            <Input
                iconPosition='left'
                icon={<Icon name='calendar alternate outline' />}
                placeholder={i18next.t('datePickers.dateTimePicker.inputPlaceholder')}
                readOnly
                tabIndex="-1"
                className="ant-calendar-picker-input ant-input pi-date-picker-input"
                style={pickerInputStyle}
                value={value && value.format(DATE_TIME_FORMAT) || ''}
            />
        );
    }

    renderTimePicker() {
        return <TimePickerPanel
            defaultValue={moment('00:00:00', 'HH:mm:ss')}
            showSecond={false}
            placement='top'
            className="pi-time-picker"
            style={this.props.timeStyle} />;
    }

    renderCalendar() {
        const { defaultCalendarValue, calendarStyle } = this.props;

        return <Calendar
            locale={i18next.language === 'he' ? heIL : enUS}
            dateInputPlaceholder={i18next.t('datePickers.dateTimePicker.calendarPlaceholder')}
            defaultValue={defaultCalendarValue}
            // disabledDate={(currentDate) => moment().isAfter(currentDate)}
            format={DATE_TIME_FORMAT}
            placement='left'
            timePicker={this.renderTimePicker()}
            showOk={false}
            style={{ width: '27.5em', ...calendarStyle }}
            className="pi-date-time-calendar"
        />;
    }

    render() {
        const {
            onChange, value,
            calendarStyle, timeStyle, pickerInputStyle, datePickerStyle,
            ...rest
        } = this.props;

        return (
            <DatePicker
                animation="slide-up"
                value={value}
                onChange={onChange}
                // placement="right"
                calendar={this.renderCalendar()}
                className="pi-date-time-picker"
                style={datePickerStyle}
                {...rest}
            >{this.renderPickerInput}</DatePicker>
        );

    }
}

DateTimePicker.propTypes = {
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    calendarStyle: PropTypes.object,
    timeStyle: PropTypes.object,
    pickerInputStyle: PropTypes.object,
    datePickerStyle: PropTypes.object,
};

export default DateTimePicker;
